export default __webpack_public_path__ + "static/media/capacitySquare.30f4a131.svg";